import React, { useState } from 'react'
import { useEffect } from 'react';
import { loadUser } from '../utils/Network';

export default function UserName({ id}) {

    const [user, setUser] = useState(null);

    
    useEffect(() => {
        if (id)
        loadUser(id).then(user=>{
                setUser(user)
            })
        
    }, [])

    
    
    return (
        <>
            {user && user.first_name+" "+user.last_name}
        </>
    )
}
